( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'concerns-callout', COMPONENT );
} )( app );
